import { useContext, useState, useEffect, createContext } from 'react';
import React from 'react';
import firebase from '../firebase';
import { NotificationManager } from 'react-notifications';

const auth = firebase.auth();
const db = firebase.firestore();

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  const signup = (email, password, firstName, lastName) => {
    let promise = new Promise(function (resolve, reject) {
      auth
        .createUserWithEmailAndPassword(email, password)
        .then(async (ref) => {
          ref.user.updateProfile({
            firstName: firstName,
            lastName: lastName,
          });
          await db.collection('users').doc(ref.user.uid).set({
            email: email,
            firstName: firstName,
            lastName: lastName,
            role: 'user',
          });

          resolve(ref);
          NotificationManager.success('Signup Success', 'Success!');
        })
        .catch((error) => {
          reject(error);
          NotificationManager.error('Signup Failure', 'Failure!');
        });
    });
    return promise;
  };

  const signin = (email, password) => {
    let promise = new Promise(function (resolve, reject) {
      auth
        .signInWithEmailAndPassword(email, password)
        .then((ref) => {
          resolve(ref);
          NotificationManager.success('Login Success', 'Success!');
        })
        .catch((error) => {
          reject(error);
          NotificationManager.error('Login Failure', 'Failure!');
        });
    });
    return promise;
  };

  const signout = () => {
    NotificationManager.success('Login out Success', 'Success!');
    return auth.signOut();
  };

  const passwordReset = (email) => {
    let promise = new Promise(function (resolve, reject) {
      auth
        .sendPasswordResetEmail(email)
        .then(() => {
          resolve(`Password Reset Email sent to ${email}`);
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, [currentUser]);

  const value = {
    currentUser,
    signup,
    signin,
    signout,
    passwordReset,
  };

  return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
}
